<div class="travelers-container">
  <h5 class="text-white">Travelers</h5>

  <div class="search-form" [formGroup]="searchForm">
    <div class="form-row">
      <!-- Organization Dropdown -->
      <div class="form-group">
        <label for="organization">Org:</label>
        <select
          id="organization"
          formControlName="organization"
          class="form-control"
          style="display: inline-block; font-size: 12px"
          (change)="loadTravelers()"
          >
          @for (org of organizations; track org) {
            <option [value]="org.id">
              {{ org.label }}
            </option>
          }
        </select>
      </div>

      <!-- Date Range Dropdown -->
      <div class="form-group">
        <label for="dateRange">Dates:</label>
        <select
          id="dateRange"
          formControlName="dateRange"
          class="form-control"
          style="display: inline-block; font-size: 12px"
          (change)="loadTravelers()"
          >
          @for (range of dateRanges; track range) {
            <option [value]="range.dayDiff">
              {{ range.label }}
            </option>
          }
        </select>
      </div>

      <div class="form-group mySearchFilter">
        <label for="searchText">Text:</label>
        <div class="search-input-container incident-search-wrapper">
          <input
            type="text"
            id="searchText"
            formControlName="searchText"
            class="form-control"
            placeholder="search term"
            (input)="onSearchTextChanged()"
            (keyup.enter)="loadTravelers()"
            list="indexTextInputList"
            />
            <datalist id="indexTextInputList">
              @for (item of availableIndexTextShow; track item) {
                <option [value]="item"></option>
              }
            </datalist>
            @if (searchForm.value.searchText) {
              <button
                class="clear-button"
                type="button"
                (click)="clearSearchText()"
                title="Clear"
                >
                <i class="fa fa-times"></i>
              </button>
            }
            <button
              class="search-button"
              type="button"
              (click)="loadTravelers()"
              title="Search"
              >
              <i class="fa fa-search"></i>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Results header -->
    <div class="results-header" style="border-bottom: solid 1px #666; padding-bottom: 5px; margin-top: 10px;">
      <span>Results: {{ travelers.length }}</span>
      @if (travelers.length > 0) {
        <button
          class="message-button"
          (click)="onSendMessage()"
          title="Send mail"
          style="margin-left: 20px;"
          >
          <i class="fa fa-envelope-o"></i>
        </button>
      }
    </div>

    <!-- Travelers list -->
    @if (!isLoading) {
      <div class="travelers-list">
        <div class="list-header">
          <label class="checkbox-container">
            <input
              type="checkbox"
              [checked]="allChecked"
              (change)="onCheckAllChanged()"
              />
              <span class="checkmark"></span>
              select all
            </label>
          </div>
          <div class="list-content">
            @for (traveler of travelers; track traveler) {
              <div class="traveler-item" style="border-bottom: solid 1px #666;">
                <label class="checkbox-container">
                  <input
                    type="checkbox"
                    [(ngModel)]="traveler.checked"
                    (change)="onCheckItemChanged()"
                    style="margin-left: 10px"
                    />
                    <span class="checkmark"></span>
                  </label>
                  <span
                    class="traveler-name"
                    (click)="onViewTravelerDetails(traveler)"
                    style="cursor: pointer; margin-left: 5px"
                    title="travel info"
                    >
                    {{ traveler.userFullName }}
                  </span>
                  <button
                    class="info-button"
                    (click)="onViewTravelerDetails(traveler)"
                    style="margin-right: 10px"
                    title="user info"
                    >
                    <i class="fa fa-info-circle"></i>
                  </button>
                </div>
              }
            </div>
          </div>
        }

        @if (isLoading) {
          <div class="loading-spinner">
            <i class="fa fa-spinner fa-spin"></i>
          </div>
        }
      </div>